class WtSeo {
    constructor() {
        this.teamPageTitle = 'Team'
        this.conversationalEngagementTitle = 'Conversational Engagement on WhatsApp Business'
        this.featuredChatbotTemplateTitle = 'Chatbot Templates'
    }
}
export const getSeo = new WtSeo()